module.exports = __webpack_public_path__ + "static/media/expand.8f269d98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/CompanyPublic/img/expand.svg
// module id = 6962
// module chunks = 0